module.exports = __webpack_public_path__ + "media/assets/images/image-placeholder-square-a9cf225c25e4de62c69d21bbe9468a50.jpg";